export default {
  title: 'Creating Dynamic Service Order',
  title_edit: 'Editing Dynamic Service Order',

  //sections ___________________________________
  generalSectionName: 'Name*',
  generalSectionChecklist: 'Checklist*',
  generalSectionType: 'Place type',
  generalSectionLevel: 'Place level',
  generalSectionPlace: 'Place',
  generalSectionDescription: 'Description*',

  themeSectionTitle: 'Theme',
  themeLogo: 'Logo',
  themeColor: 'Color',

  redirectionSection: 'Redirection',
  redirectionLabel: 'After responding, redirects to execution',

  completionSection: 'Settings of conclusion',
  completionTitleMessage: 'Completion message title',
  completionBodyMessage: 'Completion message body'
}
